import { cn } from '@frontend/ui/lib/utils';
import type { HTMLAttributes } from 'react';

export const ContainerList = ({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card grid grid-cols-1 gap-4 px-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs lg:px-6 @xl/main:grid-cols-2 @5xl/main:grid-cols-4 overflow-hidden',
			className,
		)}
		{...rest}
	/>
);
